'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
'use strict';

var ceil = Math.ceil;
var abs = Math.abs;var isFinite = Number.isFinite;

var error = function error(message) {

    throw new Error(message);
};

exports['default'] = function (_x, toNum) {
    var fromNum = arguments[0] === undefined ? 0 : arguments[0];
    var step = arguments[2] === undefined ? 1 : arguments[2];

    !isFinite(fromNum) || toNum !== undefined && !isFinite(toNum) || !isFinite(step) && error('Wrong number value!');

    typeof toNum === 'undefined' && (toNum = fromNum, fromNum = 0);

    if (step === 0) {

        error('Step should not be 0');
    } else if (step === 1) {

        fromNum > toNum && (step = -step);
    } else if (fromNum > toNum && step > 0 || fromNum < toNum && step < 0) {

        return [];
    }

    var ln = ceil(abs((toNum - fromNum) / step)),
        i = 0;
    var range = new Array(ln);

    for (; i < ln; i++) range[i] = fromNum + step * i;

    return range;
};

module.exports = exports['default'];

